import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";

@Injectable({
    providedIn: "root"
  })
  
export class AdminRoleService extends ApiBaseService {
    constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
      super(us);
      this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId, 'APIKEY': 'ams-direct-api-admin-key', }) };
      this.baseUrl = `${this.configService.config.adminUrl}/api/role`;
    }
    
    getEmployeeRoles(employeeIds: number[]): Observable<any> {
      
      let vmGetEmployeeBalances = {
        EmployeeIds: employeeIds
      }
  
      return this.http.post<any>(`${this.baseUrl}/GetEmployeeRoles`, vmGetEmployeeBalances, this.httpOptions)
                                .pipe(catchError(this.handleError<boolean>(`Failed to get employeeroles`)));
    }

    getMyRoles(): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetRolesOfSignedInEmployee`, this.httpOptions)
    }

    updateEmployeeRoles(employeeRoles: any[]) {
      return this.http.post<any>(`${this.baseUrl}/UpdateEmployeeRoles`, employeeRoles, this.httpOptions);
    }

    getApprovalLevels(): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetApprovalLevels`, this.httpOptions);
    }

    saveApprovalLevel(roleApprovalLevel: any): Observable<any> {
      return this.http.post<any>(`${this.baseUrl}/PostApprovalLevel`, roleApprovalLevel, this.httpOptions);
    }

    deleteApprovalLevel(roleApprovalLevelId: number): Observable<any> {
      return this.http.delete<any>(`${this.baseUrl}/DeleteApprovalLevel?roleApprovalLevelId=${roleApprovalLevelId}`, this.httpOptions);
    }

    deleteMultipleApprovalLevels(ids: number[]): Observable<any> {
  
      let roleApprovalLevelIds = "";
      ids.forEach(roleApprovalLevelId => {
  
        roleApprovalLevelIds += "roleApprovalLevelIds=" + roleApprovalLevelId;
        if (roleApprovalLevelId != ids[ids.length - 1]) {
          roleApprovalLevelIds += "&";
        }
      });
  
  
      return this.http.delete<any>(`${this.baseUrl}/DeleteMultipleApprovalLevels?${roleApprovalLevelIds}`, this.httpOptions);
    }

    getRoles(): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetRoles`, this.httpOptions);
    }

    getCategories(): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetCategories`, this.httpOptions);
    }

    getStatuses(): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetStatuses`, this.httpOptions);
    }

    getAllStatuses(): Observable<any[]> {
      return this.http.get<any[]>(`${this.baseUrl}/GetAllStatuses`, this.httpOptions);
    }

    getFinalCategoryStatuses(): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetFinalCategoryStatuses`, this.httpOptions);
    }
  
    getAvailableApprovalLevels(): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetApprovalLevelsToEmployee?employeeId=${this.userService.account.EmployeeId}`, this.httpOptions);
    }
  
    getAvailableApprovalLevelsByCategories(categoryIds: number[]): Observable<any> {
      let sCategoryIds = "";
      categoryIds.forEach(categoryId => {
  
        sCategoryIds += "categoryIds=" + categoryId;
        if (categoryId != categoryIds[categoryIds.length - 1]) {
          sCategoryIds += "&";
        }
      });
      return this.http.get<any>(`${this.baseUrl}/GetApprovalLevelsToEmployeeByCategory?${sCategoryIds}&employeeId=${this.userService.account.EmployeeId}`, this.httpOptions);
    }
  
    getAvailableApprovalLevelStatuses(): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetApprovalLevelStatusesToEmployee?employeeId=${this.userService.account.EmployeeId}`, this.httpOptions);
    }

    getMyApprovalLevelStatusesFromApprovalFunction(approvalFunction: number): Observable<any> {
      return this.http.get<any>(`${this.baseUrl}/GetApprovalLevelStatusIdByApprovalFunction?approvalFunction=${approvalFunction}`, this.httpOptions);
    }

}
